"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESpotOrderType = exports.ESpotOrderStatus = void 0;
var ESpotOrderStatus;
(function (ESpotOrderStatus) {
    ESpotOrderStatus["NEW"] = "NEW";
    ESpotOrderStatus["PARTIALLY_FILLED"] = "PARTIALLY_FILLED";
    ESpotOrderStatus["FILLED"] = "FILLED";
    ESpotOrderStatus["CANCELED"] = "CANCELED";
    ESpotOrderStatus["PENDING_CANCEL"] = "PENDING_CANCEL";
    ESpotOrderStatus["REJECTED"] = "REJECTED";
    ESpotOrderStatus["EXPIRED"] = "EXPIRED";
    ESpotOrderStatus["EXPIRED_IN_MATCH"] = "EXPIRED_IN_MATCH";
})(ESpotOrderStatus = exports.ESpotOrderStatus || (exports.ESpotOrderStatus = {}));
var ESpotOrderType;
(function (ESpotOrderType) {
    ESpotOrderType["LIMIT"] = "LIMIT";
    ESpotOrderType["LIMIT_MAKER"] = "LIMIT_MAKER";
    ESpotOrderType["MARKET"] = "MARKET";
    ESpotOrderType["STOP_LOSS"] = "STOP_LOSS";
    ESpotOrderType["STOP_LOSS_LIMIT"] = "STOP_LOSS_LIMIT";
    ESpotOrderType["TAKE_PROFIT"] = "TAKE_PROFIT";
    ESpotOrderType["TAKE_PROFIT_LIMIT"] = "TAKE_PROFIT_LIMIT";
})(ESpotOrderType = exports.ESpotOrderType || (exports.ESpotOrderType = {}));
